import { Phone, Mail, MapPin, Download } from "lucide-react";
import QRCard from "../QRCard";

export default function Footer({ onInstall }) {
  return (
    <footer
      data-testid="footer"
      className="relative bg-[#070C08] text-white overflow-hidden"
    >
      <div
        className="absolute inset-0 opacity-10 mix-blend-overlay"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/13956349/pexels-photo-13956349.jpeg?auto=compress&cs=tinysrgb&w=1600')",
          backgroundSize: "cover",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#FF5A00] flex items-center justify-center">
              <span className="font-heading text-xl text-white leading-none">
                HC
              </span>
            </div>
            <div className="font-heading text-3xl tracking-wider">
              Hurricane Cuts
            </div>
          </div>
          <p className="text-white/70 font-body max-w-md leading-relaxed">
            Brevard County's tree removal, trimming, stump grinding, landscaping
            and pool build specialists. Owned and operated by Ben — an arborist
            with a decade in the field. Proudly serving Rockledge, Melbourne,
            Cocoa, Cocoa Beach, Merritt Island, Cape Canaveral, Titusville and
            Viera, Florida.
          </p>
          {onInstall && (
            <button
              data-testid="footer-install-button"
              onClick={onInstall}
              className="btn-primary mt-6 !py-3 !px-5 !text-base"
            >
              <Download size={16} /> Install App on Your Phone
            </button>
          )}
          {!onInstall && (
            <div className="mt-6 border border-[#2A332C] p-4 text-sm text-white/60 font-body">
              <span className="font-accent tracking-[0.2em] uppercase text-[#FF5A00] text-xs block mb-1">
                Install Tip
              </span>
              On iPhone, tap <strong>Share → Add to Home Screen</strong>. On
              Android, tap the browser menu → <strong>Install App</strong>.
            </div>
          )}

          <div className="mt-6 hidden md:block">
            <QRCard
              variant="compact"
              size={110}
              label="Scan to visit on your phone"
              testId="qr-footer"
            />
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-heading text-xl tracking-wider text-[#FF5A00] mb-4">
            Service Areas
          </div>
          <ul className="space-y-2 text-white/70 font-body text-sm">
            <li>Rockledge, FL</li>
            <li>Melbourne, FL</li>
            <li>Cocoa, FL</li>
            <li>Cocoa Beach, FL</li>
            <li>Merritt Island, FL</li>
            <li>Cape Canaveral, FL</li>
            <li>Titusville, FL</li>
            <li>Viera, FL</li>
            <li>Brevard County, FL</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-heading text-xl tracking-wider text-[#FF5A00] mb-4">
            Contact
          </div>
          <ul className="space-y-3 text-white/85 font-body">
            <li>
              <a
                href="tel:+13216826085"
                className="flex items-center gap-3 hover:text-[#FF5A00]"
              >
                <Phone size={16} /> (321) 682-6085
              </a>
            </li>
            <li>
              <a
                data-testid="footer-phone-secondary"
                href="tel:+13219994458"
                className="flex items-center gap-3 hover:text-[#FF5A00]"
              >
                <Phone size={16} /> (321) 999-4458
              </a>
            </li>
            <li>
              <a
                href="mailto:Lordsmith945@gmail.com"
                className="flex items-center gap-3 hover:text-[#FF5A00] break-all"
              >
                <Mail size={16} /> Lordsmith945@gmail.com
              </a>
            </li>
            <li>
              <a
                href="mailto:skylars3838@gmail.com"
                className="flex items-center gap-3 hover:text-[#FF5A00] break-all"
              >
                <Mail size={16} /> skylars3838@gmail.com
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin size={16} /> Brevard County, FL
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-[#2A332C]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="font-accent text-xs tracking-[0.2em] uppercase text-white/50">
            © {new Date().getFullYear()} Hurricane Cuts — All rights reserved
          </div>
          <div className="font-accent text-xs tracking-[0.2em] uppercase text-white/50">
            Tree Service · Brevard County, FL · Licensed · Insured
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6 text-center text-white/35 font-body text-xs leading-relaxed">
          Tree service Rockledge · Tree removal Melbourne · Tree trimming Cocoa
          · Palm trimming Cocoa Beach · Stump grinding Merritt Island · Arborist
          Cape Canaveral · Landscaping Titusville · Pool builds Viera · Storm
          damage cleanup Brevard County, Florida · Hurricane Cuts Rockledge FL
        </div>
      </div>
    </footer>
  );
}
